import { jsonTryParse } from '@ztechapps/common.utils'
import type { DbOptions } from '../types/QueryInput'

export type BuildFetchMoreQueryParams = {
  modelName: string
  fetchMore: any
  skip: number
  searchString: string
  sortObject: any
  limit?: number
  dbOptions?: DbOptions
}

export const buildFetchMoreQuery = ({
  modelName,
  fetchMore,
  skip,
  searchString,
  sortObject,
  limit = 10,
  dbOptions = {},
}: BuildFetchMoreQueryParams) => {
  const variables = {
    filter: jsonTryParse(searchString),
    options: {
      skip,
      limit,
      sort: jsonTryParse(sortObject),
      ...dbOptions,
    },
  }

  const updateQuery = (previousResult, { fetchMoreResult }) => {
    if (!fetchMoreResult) {
      return previousResult
    }

    const previousData = previousResult[modelName] || []
    const fetchMoreData = fetchMoreResult[modelName] || []

    return Object.assign({}, previousResult, {
      [modelName]: [...previousData, ...fetchMoreData],
    })
  }

  return fetchMore({
    variables,
    updateQuery,
  })
}
